import { library } from '@fortawesome/fontawesome-svg-core';
// lib
import {
  faUpload,
  faFutbol,
  faWaterLadder,
  faTable,
  faMapLocation,
  faCalendar,
  faMapMarkerAlt,
  faUsersCog,
  faMoneyCheckDollarPen,
  faGaugeMed,
  faPencilRuler,
  faSearch,
  faCalendarPlus,
  faChartLine,
  faAngleRight,
  faUsers,
  faShirt,
  faUserFriends,
  faUserTie,
  faUserSecret,
  faHand,
  faChalkboardUser,
  faCircleExclamation,
  faAward,
  faUserMinus,
  faCircleCheck,
  faCircleMinus,
  faSuitcase,
  faImagesUser,
  faFolderMagnifyingGlass,
  faSitemap,
  faGears,
  faMagnifyingGlass,
  faFontAwesome,
  faTrophyStar,
  faEnvelopeOpenDollar,
  faEllipsisVertical,
  faEllipsisStrokeVertical,
  faMoneyBills,
  faTableLayout,
  faSwords,
  faCloudArrowDown,
  faSquareX,
  faEnvelopesBulk,
  faRetweet,
  faTicket,
  faGrid,
  faLongArrowAltRight,
  faBuildingFlag,
  faHorizontalRule,
  faPenToSquare,
  faLink,
  faTrashCanXmark,
  faCheck,
  faXmark,
  faClipboardListCheck,
  faDownload,
  faExpand,
  faWhistle,
  faFileSlash,
  faMobileNotch,
  faTabletButton,
  faDesktop,
  faTrophy,
  faBadgeCheck,
  faPeopleGroup,
  faUserPlus,
  faCircleEllipsisVertical,
} from '@fortawesome/pro-light-svg-icons';

import {
  faTrashXmark,
  faBold,
  faItalic,
  faH1,
  faArrowsUpDownLeftRight,
  faArrowUp,
  faArrowDown,
  faSort,
  faPlus,
  faTrash,
  faAsterisk,
  faMessagePen,
  faChevronsRight,
  faChevronsLeft,
  faBars,
  faH2,
  faH3,
  faHighlighter,
  faStrikethrough,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faImage,
  faMemo,
} from '@fortawesome/pro-regular-svg-icons';

/* Pro Light Icons */
library.add(
  faExpand,
  faClipboardListCheck,
  faUpload,
  faFutbol,
  faWaterLadder,
  faTable,
  faMapLocation,
  faCalendar,
  faMapMarkerAlt,
  faUsersCog,
  faMoneyCheckDollarPen,
  faCircleExclamation,
  faGaugeMed,
  faPencilRuler,
  faSearch,
  faCalendarPlus,
  faChartLine,
  faAngleRight,
  faUsers,
  faAward,
  faUserMinus,
  faCircleMinus,
  faImagesUser,
  faFolderMagnifyingGlass,
  faSitemap,
  faGears,
  faMagnifyingGlass,
  faFontAwesome,
  faTrophyStar,
  faEnvelopeOpenDollar,
  faEllipsisVertical,
  faEllipsisStrokeVertical,
  faMoneyBills,
  faTableLayout,
  faSwords,
  faCircleCheck,
  faCircleExclamation,
  faUserFriends,
  faUserTie,
  faUserSecret,
  faCloudArrowDown,
  faBadgeCheck,
  faSquareX,
  faEnvelopesBulk,
  faRetweet,
  faTicket,
  faGrid,
  faPeopleGroup,
  faLongArrowAltRight,
  faBuildingFlag,
  faHorizontalRule,
  faPenToSquare,
  faLink,
  faTrashCanXmark,
  faCheck,
  faXmark,
  faDownload,
  faMoneyCheckDollarPen,
  faFileSlash,
  faMobileNotch,
  faTabletButton,
  faDesktop,
  faCircleEllipsisVertical,
);

/* Pro Regular Icons */
library.add(
  faCircleExclamation,
  faUserPlus,
  faTrashXmark,
  faXmark,
  faBold,
  faItalic,
  faLink,
  faH1,
  faArrowsUpDownLeftRight,
  faArrowUp,
  faArrowDown,
  faSort,
  faPlus,
  faTrash,
  faAsterisk,
  faChevronsRight,
  faChevronsLeft,
  faMessagePen,
  faBars,
  faH2,
  faH3,
  faHighlighter,
  faStrikethrough,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faImage,
  faWhistle,
  faMemo,
  faSuitcase,
  faShirt,
  faChalkboardUser,
  faHand,
  faPeopleGroup,
  faBadgeCheck,
  faTrophy,
);

export default library;
